var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.language["depart"],
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        okButtonProps: { props: { disabled: _vm.confirmLoading } },
        cancelButtonProps: { props: { disabled: _vm.confirmLoading } },
        okText: _vm.language["common.importButton"],
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "a-col",
            { attrs: { md: 10, sm: 24 } },
            [_c("a-tree", { attrs: { treeData: _vm.departTree } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }